import React from "react";
import { TableCell, Checkbox, Button, Box, Divider } from "@material-ui/core";
import { convertDate } from "../../utils/dateConverter";

export const baseConfig = {
  mainRowCells: [
    (data) => (
      <TableCell key="base">
        {data.components[0].deviceCalibration.base}
      </TableCell>
    ),
    (data) => <TableCell key="count">{data.components.length}</TableCell>,
  ],
  collapsibleHeaders: [
    "#",
    "Aktywna",
    "Model",
    "500Hz",
    "1000Hz",
    "2000Hz",
    "4000Hz",
    "Opcje",
  ],
  collapsibleRowRender: (
    component,
    index,
    { mainCalibrations, removeGroupHandler, checkBoxes, handleCheckboxChange }
  ) => {
    if (!component.deviceCalibration) {
      return (
        <TableCell colSpan={8}>
          Brak danych kalibracyjnych dla tego komponentu.
        </TableCell>
      );
    }

    const componentId = component.deviceCalibration.id;

    return (
      <React.Fragment key={index}>
        <TableCell>{index + 1}</TableCell>
        <TableCell>
          <Checkbox
            key={componentId}
            checked={checkBoxes[componentId] ?? false}
            onChange={() => handleCheckboxChange(componentId)}
          />
        </TableCell>
        <TableCell>{component.deviceCalibration.manufacturer}</TableCell>
        {component.deviceCalibration.calibrations !== null ? (
          component.deviceCalibration.calibrations.map(
            (calibration, calIndex) => {
              const difference =
                mainCalibrations?.[calIndex] !== undefined
                  ? calibration.appVolume - mainCalibrations[calIndex]
                  : "Brak danych";

              return (
                <TableCell key={calIndex}>
                  <Box>
                    {calibration.appVolume} <Divider />
                    {difference}
                  </Box>
                </TableCell>
              );
            }
          )
        ) : (
          <TableCell colSpan={4}>Brak Danych</TableCell>
        )}
        <TableCell>
          <Button
            onClick={() => removeGroupHandler(component.deviceCalibration.id)}
          >
            Remove
          </Button>
        </TableCell>
      </React.Fragment>
    );
  },
};

export const modelConfig = {
  mainRowCells: [
    (data) => <TableCell key="manufacturer">{data.manufacturer}</TableCell>,
    (data) => <TableCell key="model">{data.model}</TableCell>,
    (data) => <TableCell key="count">{data.components.length}</TableCell>,
  ],
  collapsibleHeaders: [
    "#",
    "Aktywna",
    "Data",
    "500 hz",
    "1000 hz",
    "2000 hz",
    "4000 hz",
    "Opcje",
  ],
  collapsibleRowRender: (
    component,
    index,
    { mainCalibrations, removeGroupHandler, checkBoxes, handleCheckboxChange }
  ) => {
    if (!component.deviceCalibration) {
      return (
        <TableCell colSpan={8}>
          Brak danych kalibracyjnych dla tego komponentu.
        </TableCell>
      );
    }

    const componentId = component.deviceCalibration.id;
    return (
      <React.Fragment key={index}>
        <TableCell>{index + 1}</TableCell>
        <TableCell>
          <Checkbox
            key={componentId}
            checked={checkBoxes[componentId] ?? false}
            onChange={() => handleCheckboxChange(componentId)}
          />
        </TableCell>
        <TableCell>
          {convertDate(component.deviceCalibration.createdAt)}
        </TableCell>
        {component.deviceCalibration.calibrations !== null ? (
          component.deviceCalibration.calibrations.map(
            (calibration, calIndex) => {
              const difference =
                mainCalibrations?.[calIndex] !== undefined
                  ? calibration.appVolume - mainCalibrations[calIndex]
                  : "Brak danych";

              return (
                <TableCell key={calIndex}>
                  <Box>
                    {calibration.appVolume} <Divider />
                    {difference}
                  </Box>
                </TableCell>
              );
            }
          )
        ) : (
          <TableCell colSpan={4}>Brak Danych</TableCell>
        )}
        <TableCell>
          <Button
            onClick={() => removeGroupHandler(component.deviceCalibration.id)}
          >
            Remove
          </Button>
        </TableCell>
      </React.Fragment>
    );
  },
};

export const brandConfig = {
  mainRowCells: [
    (data) => <TableCell key="manufacturer">{data.brand}</TableCell>,
    (data) => <TableCell key="count">{data.components.length}</TableCell>,
  ],
  collapsibleHeaders: [
    "#",
    "Aktywna",
    "Model",
    "500 hz",
    "1000 hz",
    "2000 hz",
    "4000 hz",
    "Opcje",
  ],
  collapsibleRowRender: (
    component,
    index,
    { mainCalibrations, removeGroupHandler, checkBoxes, handleCheckboxChange }
  ) => {
    if (!component.deviceCalibration) {
      return (
        <TableCell colSpan={8}>
          Brak danych kalibracyjnych dla tego komponentu.
        </TableCell>
      );
    }
    const componentId = component.deviceCalibration.id;

    return (
      <React.Fragment key={index}>
        <TableCell>{index + 1}</TableCell>
        <TableCell>
          <Checkbox
            key={componentId}
            checked={checkBoxes[componentId] ?? false}
            onChange={() => handleCheckboxChange(componentId)}
          />
        </TableCell>
        <TableCell>{component.deviceCalibration.model}</TableCell>
        {component.deviceCalibration.calibrations !== null ? (
          component.deviceCalibration.calibrations.map(
            (calibration, calIndex) => {
              const difference =
                mainCalibrations?.[calIndex] !== undefined
                  ? calibration.appVolume - mainCalibrations[calIndex]
                  : "Brak danych";

              return (
                <TableCell key={calIndex}>
                  <Box>
                    {calibration.appVolume} <Divider />
                    {difference}
                  </Box>
                </TableCell>
              );
            }
          )
        ) : (
          <TableCell colSpan={4}>Brak Danych</TableCell>
        )}
        <TableCell>
          <Button
            onClick={() => removeGroupHandler(component.deviceCalibration.id)}
          >
            Remove
          </Button>
        </TableCell>
      </React.Fragment>
    );
  },
};

export const manufacturerConfig = {
  mainRowCells: [
    (data) => <TableCell key="manufacturer">{data.manufacturer}</TableCell>,
    (data) => <TableCell key="count">{data.components.length}</TableCell>,
  ],
  collapsibleHeaders: [
    "#",
    "Aktywna",
    "Model",
    "500 hz",
    "1000 hz",
    "2000 hz",
    "4000 hz",
    "Opcje",
  ],
  collapsibleRowRender: (
    component,
    index,
    { mainCalibrations, removeGroupHandler, checkBoxes, handleCheckboxChange }
  ) => {
    if (!component.deviceCalibration) {
      return (
        <TableCell colSpan={8}>
          Brak danych kalibracyjnych dla tego komponentu.
        </TableCell>
      );
    }
    const componentId = component.deviceCalibration.id;

    return (
      <React.Fragment key={index}>
        <TableCell>{index + 1}</TableCell>
        <TableCell>
          <Checkbox
            key={componentId}
            checked={checkBoxes[componentId] ?? false}
            onChange={() => handleCheckboxChange(componentId)}
          />
        </TableCell>
        <TableCell>{component.deviceCalibration.brand}</TableCell>
        {component.deviceCalibration.calibrations !== null ? (
          component.deviceCalibration.calibrations.map(
            (calibration, calIndex) => {
              const difference =
                mainCalibrations?.[calIndex] !== undefined
                  ? calibration.appVolume - mainCalibrations[calIndex]
                  : "Brak danych";

              return (
                <TableCell key={calIndex}>
                  <Box>
                    {calibration.appVolume} <Divider />
                    {difference}
                  </Box>
                </TableCell>
              );
            }
          )
        ) : (
          <TableCell colSpan={4}>Brak Danych</TableCell>
        )}
        <TableCell>
          <Button
            onClick={() => removeGroupHandler(component.deviceCalibration.id)}
          >
            Remove
          </Button>
        </TableCell>
      </React.Fragment>
    );
  },
};
